<div class="container">
    <h2 class="heading">Cart UX Admin Page</h2>

    <div *ngIf="isAdminDisabled" class="overlay"></div>

    <!-- Question prompt section -->
    <div *ngIf="isAdminDisabled" class="admin-question">
        <div>What was the shop team's original name?</div>
        <input type="text" class="form-control" [(ngModel)]="adminAnswer" size="20" (keyup.enter)="checkAnswer()">
        <universal-button [data]="{type: 'primary', size: 'small'}" (click)="checkAnswer()">Unlock</universal-button>
        {{wrongAnswer}}
    </div>

    <div class="admin-section" >
        <div><a href="#/admin/dashboard" class="button-link">Shop Session Dashboard</a></div>

        <h4>Product Actions</h4>
        <div class="product-group">
            <div>
                country (US): <input type="text" class="simple-text-input" [(ngModel)]="productLoadCountry" size="3"  >
                productId (101.010101): <input type="text" class="simple-text-input" [(ngModel)]="productLoadProductId" size="11"  >
                <a class="gray-button-link" (click)="singleProductLoadByCountry()">Manual Product Load</a>
            </div>
            (Occasionally product updates will not be detected and shop product will be missing or outdated)<br><br>
            <div><a class="gray-button-link" (click)="clearProductCache()" >Clear Product Cache</a></div>
            <h4>Product Updates</h4>
            These use the views to find changes in odyssey vs phoenix products.<br>
            This happens every 5 minutes in the prods, non-prods.  This is mostly for debugging locally
            <div class="product-group">
                <div>
                    country (US): <input type="text" class="simple-text-input" [(ngModel)]="syncProductLoadCountry" size="3"  >
                    productId (101.010101): <input type="text" class="simple-text-input" [(ngModel)]="syncProductLoadProductId" size="11"  >
                    <a class="gray-button-link" (click)="syncProductsByCountryAndProductId()">Check for product changes</a>
                </div>
                <div>
                    country (US): <input type="text" class="simple-text-input" [(ngModel)]="syncProductLoadCountryOny" size="3"  >
                    <a class="gray-button-link" (click)="syncProductsByCountry()">Check for product changes</a>
                </div>
                <div>
                    <a class="gray-button-link" (click)="syncProducts()">Check for all product changes</a>
                </div>
            </div>
            <div><a class="gray-button-link" (click)="loadRecommendedProducts()" >Reload Recommended Products</a></div>
            <div>
                country (US, SG): <input type="text" class="simple-text-input" [(ngModel)]="productInfoCountry" size="3"  >
                warehouse (SLC, SG.WC): <input type="text" class="simple-text-input" [(ngModel)]="productInfoWarehouse" size="8"  >
                language (en, zh): <input type="text" class="simple-text-input" [(ngModel)]="productInfoLanguage" size="3"  >
                product (101.010101) optional: <input type="text" class="simple-text-input" [(ngModel)]="productInfoUsanaId" size="11"  >
                <a class="gray-button-link" (click)="logProductInfo()" >Log Product Info</a>
            </div>
        </div>

        <div><a class="gray-button-link" (click)="clearTranslationCache()" >Clear Translation Cache</a></div>
        <div><a class="gray-button-link" (click)="purgeCarts()" >Purge Carts</a></div>
        <div>
            Show App Config <span class="fa-solid fa-plus" (click)="showAppConfigDebug = !showAppConfigDebug" style="cursor:pointer"></span>
            <div *ngIf="showAppConfigDebug">
                <pre>{{appConfig | json}}</pre>
            </div>
        </div>
    </div>

    <div class="secure-admin-section">
        <h3 class="heading">Secure Admin Section</h3>
        <div class="secure-admin-password">Admin Password <input type="password" class="simple-text-input" [(ngModel)]="secureAdminPassword" size="10" ></div>
        <div><a class="gray-button-link" (click)="clearAllQuartzTasks()">Clear ALL Quartz tasks</a> (will require a service restart)</div>
        <div class="quartz-grid">
            <div>
                Scheduler: <input type="text" class="simple-text-input" [(ngModel)]="schedulerTrigger" size="30" >
                Trigger: <input type="text" class="simple-text-input" [(ngModel)]="trigger" size="30" >
                <a (click)="clearQuartzTrigger()" class="gray-button-link">Clear Quartz Trigger</a>
            </div>
            <div>
                Scheduler: <input type="text" class="simple-text-input" [(ngModel)]="schedulerJob" size="30" >
                Job: <input type="text" class="simple-text-input"  [(ngModel)]="job" size="30" >
                <a (click)="clearQuartzJob()" class="gray-button-link">Clear Quartz Job</a>
            </div>
        </div>

    </div>
</div>

